import { createContext, Dispatch, SetStateAction } from 'react'

import { Salary, SalaryFilterKeyString } from 'InstitutionalManagement/types'

type CustomFormSalarySelectionDrawerManagerContextType = {
  view: string
  setView: Dispatch<SetStateAction<string>>
  selectedSalary: Salary
  setSelectedSalary: (newSalary: Salary) => void
  filter: SalaryFilterKeyString
  setFilter: Dispatch<SetStateAction<SalaryFilterKeyString>>
  questionKey: string
  salaries: Salary[]
  loadingSalaries: boolean
  setLoadingSalaries: Dispatch<SetStateAction<boolean>>
}

const defaultValue = {
  view: '',
  setView: () => {},
  selectedSalary: {},
  setSelectedSalary: () => {},
  filter: {},
  setFilter: () => {},
  questionKey: '',
  salaries: [],
  loadingSalaries: false,
  setLoadingSalaries: () => {},
}

const CustomFormSalarySelectionDrawerManagerContext =
  createContext<CustomFormSalarySelectionDrawerManagerContextType>(defaultValue)

export default CustomFormSalarySelectionDrawerManagerContext
